module.exports = __webpack_public_path__ + "img/Butterfly_00362.ec38b1cf.png";